var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_877_1447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 27.2368C22.878 27.2368 27.2375 22.8771 27.2375 17.4992C27.2375 12.1214 22.878 7.76172 17.5002 7.76172C12.1224 7.76172 7.7627 12.1214 7.7627 17.4992C7.7627 22.8771 12.1222 27.2368 17.5001 27.2368",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90662 12.7146C4.18019 11.4564 3.32633 10.1358 2.34506 8.75293C0.808844 11.4131 5.21824e-05 14.4309 2.52498e-09 17.5028C-5.21773e-05 20.5747 0.808637 23.5924 2.34476 26.2527C3.88088 28.9129 6.0903 31.1219 8.75087 32.6574C11.4114 34.193 14.4294 35.001 17.5013 35.0003C19.1119 32.7413 20.2055 31.1125 20.782 30.114C21.8892 28.1961 23.3213 25.4503 25.0781 21.8766V21.8745C24.3106 23.2052 23.2062 24.3104 21.8761 25.0789C20.5459 25.8474 19.0369 26.2521 17.5007 26.2523C15.9645 26.2525 14.4553 25.8483 13.1249 25.0802C11.7945 24.3121 10.6898 23.2073 9.92187 21.8768C7.53586 17.4269 5.86411 14.3728 4.90662 12.7146Z",
    fill: "#229342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5012 34.9994C19.7994 34.9998 22.0751 34.5474 24.1984 33.668C26.3217 32.7887 28.251 31.4997 29.876 29.8746C31.501 28.2495 32.7899 26.3202 33.6692 24.1968C34.5484 22.0734 35.0006 19.7977 35.0001 17.4995C34.9994 14.4276 34.1902 11.4099 32.6536 8.7499C29.3384 8.42314 26.8918 8.25977 25.3137 8.25977C23.5243 8.25977 20.9198 8.42314 17.5 8.7499L17.498 8.75127C19.0343 8.75051 20.5436 9.15428 21.8743 9.92197C23.2049 10.6897 24.31 11.7942 25.0783 13.1245C25.8466 14.4548 26.2511 15.964 26.2511 17.5002C26.2511 19.0364 25.8465 20.5456 25.0781 21.8759L17.5012 34.9994Z",
    fill: "#FBC116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 24.4283C21.3262 24.4283 24.4277 21.3269 24.4277 17.5008C24.4277 13.6747 21.3262 10.5732 17.5002 10.5732C13.6744 10.5732 10.5728 13.6748 10.5728 17.5008C10.5728 21.3267 13.6744 24.4283 17.5003 24.4283Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 8.75059H32.6537C31.1182 6.08998 28.9092 3.88055 26.2489 2.34447C23.5886 0.808384 20.5708 -0.000207817 17.4989 4.00638e-08C14.427 0.000207897 11.4092 0.809208 8.74914 2.34565C6.08906 3.8821 3.88039 6.09183 2.34521 8.75265L9.92203 21.8763L9.92408 21.8774C9.15539 20.5473 8.75045 19.0383 8.75 17.5021C8.74955 15.9659 9.15359 14.4566 9.92151 13.1261C10.6894 11.7956 11.7941 10.6907 13.1245 9.9226C14.4549 9.15449 15.9641 8.75023 17.5004 8.75046L17.5002 8.75059Z",
    fill: "#E33B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_877_1447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.2ee6c483df002fa1ea4b3a272642adb1.svg";
export { ForwardRef as ReactComponent };